import { toast } from "react-toastify";
import { useGetProductsMutationMutation } from "../../../../redux/slices/homeSlice";
import "./slider.scss";
import SliderChild from "./SliderChild";
import React, { useEffect, useState } from "react";
import { ProductCard } from "../../../Pages/Category/Category";
import { ARROW_BACK_IC, ARROW_FORWARD_IC } from "../../../../assets";

export default function Slider(props) {
  useEffect(() => {
    document.addEventListener("DOMContentLoaded", function () {
      const scrollImages = document.querySelector(".scroll-images");
      const scrollLength = scrollImages.scrollWidth - scrollImages.clientWidth;
      const leftButton = document.querySelector(".left");
      const rightButton = document.querySelector(".right");

      function checkScroll() {
        const currentScroll = scrollImages.scrollLeft;
        if (currentScroll === 0) {
          leftButton.setAttribute("disabled", "true");
          rightButton.removeAttribute("disabled");
        } else if (currentScroll === scrollLength) {
          rightButton.setAttribute("disabled", "true");
          leftButton.removeAttribute("disabled");
        } else {
          leftButton.removeAttribute("disabled");
          rightButton.removeAttribute("disabled");
        }
      }

      scrollImages.addEventListener("scroll", checkScroll);
      window.addEventListener("resize", checkScroll);
      checkScroll();
    });
  }, []);

  function leftScroll() {
    const scrollImages = document.querySelector(".scroll-images");
    scrollImages?.scrollBy({
      left: -200,
      behavior: "smooth",
    });
  }

  function rightScroll() {
    const scrollImages = document.querySelector(".scroll-images");
    scrollImages?.scrollBy({
      left: 200,
      behavior: "smooth",
    });
  }

  return (
    <div className="cover">
      {props?.products?.length > 0 && (
        <button className="left" onClick={leftScroll}>
          <div
            className="material-symbols-outlined"
            style={{ color: "#A9772B" }}
          >
            <img src={ARROW_BACK_IC} alt="" className="w-8" />
          </div>
        </button>
      )}
      {props?.products && (
        <div className="scroll-images cards">
          {props?.products?.slice(0, 6)?.map((item, index) => {
            return <SliderChild data={item} key={index} />;
          })}
        </div>
      )}
      {props?.products?.length > 0 && (
        <button className="right" onClick={rightScroll}>
          <div
            className="material-symbols-outlined"
            style={{ color: "#A9772B" }}
          >
            <img src={ARROW_FORWARD_IC} alt="" className="w-8" />
          </div>
        </button>
      )}
    </div>
  );
}
